import { AUTHORSEARCH, CATEGORYSEARCH, CLEARSEARCH, GENERALSEARCH } from "./actionTypes";

export const categorySearch = (category) => {
    return {
        type: CATEGORYSEARCH,
        payload: category
    };
};

export const authorSearch = (authorId) => {
    return {
        type: AUTHORSEARCH,
        payload: authorId
    };
};

export const generalsearch = (searchText) => {
    return {
        type: GENERALSEARCH,
        payload: searchText
    };
};

export const clearSearch = () => {
    return {
        type: CLEARSEARCH
    };
};